export const formatWordCount = (count: number): string => {
  if (count === 0) return '0 слов';
  return `${count} слов`;
};
